<template>
  <div class="continer-fluid">
    <b-row>
      <b-col >
        <b-card>
          <h4 class="strong" style="text-align:center">
            String Diagram {{ name }}
          </h4>
          <br />
        
            <b-row>
              <b-col sm="0">
                <img
                  src="../assets/string-diagram-vertical.png"
                  
                />
              </b-col>
              <b-col sm="3">
                <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
                <b-form-text>Pump Type</b-form-text>
                <b-form-text 
                  ><strong>
                    {{ selectedPump }} Total Stages {{ stages }} stages</strong
                  ></b-form-text
                >
                <b-form-text
                  ><strong
                    >With Frequency Design : {{ frequency }} Hz</strong
                  ></b-form-text
                >
                <br /><br /><br /><br />
                <b-form-text
                  >Gas Handler :
                  <strong> {{ gasHandler }} </strong></b-form-text
                >
                <b-form-text
                  >Gas Separator :
                  <strong> {{ gasSeparator }}</strong></b-form-text
                > <br />
                <b-form-text>Protector Type</b-form-text>
                <b-form-text>
                  <strong> Protector 1 : {{ protector1 }} </strong>
                   <strong> , Protector 2 : {{ protector2 }} </strong> <br />
                  <strong> Protector 3 : {{ protector3 }} </strong>
                  <strong> , Protector 4 : {{ protector4 }} </strong>
                  </b-form-text>
              <br /> <br /> 
                <b-form-text>Motor Type</b-form-text>
                <b-form-text>
                  <strong>
                    {{ motor1[1] }} HP , {{ motor1[2] }} Volt,
                    {{ motor1[3] }} A, {{ motor1[4] }} , Total Tandem : {{ totaltandem }} Motor</strong><br />
                   
<br />
                <b-form-text>Downhole Sensor/UMB</b-form-text>
                <b-form-text ><strong> {{ downholesensor }} </strong>
                </b-form-text>
              </b-col>
            </b-row>
          
          <hr />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BaseContainer from "../components/base/BaseContainer.vue";

export default {
  components: { BaseContainer },

  name: "string-diagram",

  created: function() {
    this.$router.app.$emit("changeTab", "string-diagram");
    // call name
    this.name = this.$core.name;

    //for call pump
    let pump = this.$core.pump.graph.graph;
    this.selectedPump = pump.pump;
    this.stages = pump.stages;
    this.frequency = pump.frequency;

    // for call gas handler
    this.gasHandler = this.$core.equipment.gasHandler;

    // call gas separator
    this.gasSeparator = this.$core.equipment.gasSeparator;

    //call protector
    this.protector1 = this.$core.equipment.protector1;
    this.protector2 = this.$core.equipment.protector2;
     this.protector3 = this.$core.equipment.protector3;
    this.protector4 = this.$core.equipment.protector4;

    //call motor
    this.motor1 = this.$core.equipment.motor1;
    
    //total tandem
    this.totaltandem = this.$core.equipment.totaltandem;
    

    //downhole sensor
    this.downholesensor = this.$core.equipment.isUsingDownholeSensor;
    if ((this.$core.equipment.isUsingDownholeSensor = "1")) {
      this.downholesensor = "Downhole Sensor";
    } else {
      this.downholesensor = "UMB";
    }
  },
};
</script>

<style>
.single-line {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
